import { END_REQUEST, START_REQUEST } from '../actions'

export default (
    state = {
        requestPending: null,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case START_REQUEST:
            return { ...state, ...data, requestPending: true }

        case END_REQUEST:
            return { ...state, ...data, requestPending: false }

        default:
            return state
    }
}
